import { useContext, useState } from 'react';
import { isWarrantyAppliedActionTypes } from '../redusers/is-warranty-applied-reducer';
import {
  bookingState,
  BookingStateCombinedState,
} from '../Pages/Booking/client-state/booking-state-context';
import {
  bookingEditState,
  BookingEditStateCombinedState,
} from '../Pages/BookingEdit/client-state/booking-edit-state-context';
import usePageType from './use-page-type';
import { graphqlSdk } from '../Utils/graphql-client';
import useBookingTracking, { bookingTrackFunction } from './useBookingTracking';
import useBookingEditTracking, {
  bookingEditTrackFunction,
} from './use-booking-edit-tracking';

const useRemoveCancellationProtection = () => {
  const pageType = usePageType();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // This hook is currently only used on the booking and edit-booking pages
  const { state: stateBooking, dispatch: dispatchBooking } = useContext(bookingState);
  const { state: stateBookingEdit, dispatch: dispatchBookingEdit } =
    useContext(bookingEditState);
  const bookingTrack = useBookingTracking();
  const bookingEditTrack = useBookingEditTracking();

  let state: BookingStateCombinedState['state'] | BookingEditStateCombinedState['state'];
  let dispatch:
    | BookingStateCombinedState['dispatch']
    | BookingEditStateCombinedState['dispatch'];
  let track: bookingTrackFunction | bookingEditTrackFunction;

  switch (pageType) {
    case 'booking': {
      state = stateBooking;
      dispatch = dispatchBooking;
      track = bookingTrack;
      break;
    }
    case 'edit-booking': {
      state = stateBookingEdit;
      dispatch = dispatchBookingEdit;
      track = bookingEditTrack;
      break;
    }
    default: {
      state = stateBooking;
      track = bookingTrack;
      break;
    }
  }

  const removeCancellationProtection = async () => {
    if (state.booking.id) {
      try {
        setLoading(true);
        setError(false);
        await graphqlSdk.removeCancellationWarranty({
          bookingId: state.booking.id,
        });

        dispatch({
          type: isWarrantyAppliedActionTypes.SET_IS_APPLIED,
          payload: false,
        });

        track({ type: 'REMOVE_WARRANTY_FROM_CART', boatCount: state.booking.boatCount });
      } catch {
        setError(true);
        setLoading(false);
      }
    } else {
      dispatch({
        type: isWarrantyAppliedActionTypes.SET_IS_APPLIED,
        payload: false,
      });

      track({ type: 'REMOVE_WARRANTY_FROM_CART', boatCount: state.booking.boatCount });
    }
  };

  return {
    removeCancellationProtection,
    loading,
    error,
  };
};

export default useRemoveCancellationProtection;
